import React from 'react';

/** **bold** → <strong>; everything else is plain text (no HTML from the server is ever injected). */
const renderInline = (text, keyPrefix) =>
  text.split(/(\*\*[^*]+\*\*)/g).filter(Boolean).map((part, i) =>
    part.startsWith('**') && part.endsWith('**')
      ? <strong key={`${keyPrefix}-${i}`}>{part.slice(2, -2)}</strong>
      : part
  );

/**
 * Minimal markdown used by the legal documents (admin → Юр. документы):
 * "## " / "# " headings, "- " list items, blank line = paragraph break, **bold**.
 */
export function renderLegalMarkdown(source) {
  const blocks = [];
  let paragraph = [];
  let list = [];

  const flushParagraph = () => {
    if (paragraph.length) {
      const k = `p${blocks.length}`;
      blocks.push(<p key={k} className="legal-doc__p">{renderInline(paragraph.join(' '), k)}</p>);
      paragraph = [];
    }
  };
  const flushList = () => {
    if (list.length) {
      const k = `ul${blocks.length}`;
      blocks.push(
        <ul key={k} className="legal-doc__ul">
          {list.map((item, i) => <li key={i}>{renderInline(item, `${k}-${i}`)}</li>)}
        </ul>
      );
      list = [];
    }
  };

  (source || '').split(/\r?\n/).forEach((raw) => {
    const line = raw.trim();
    if (!line) {
      flushParagraph();
      flushList();
      return;
    }
    const heading = line.match(/^#{1,3}\s+(.*)$/);
    if (heading) {
      flushParagraph();
      flushList();
      const k = `h${blocks.length}`;
      blocks.push(<h3 key={k} className="legal-doc__h">{renderInline(heading[1], k)}</h3>);
      return;
    }
    const item = line.match(/^[-*]\s+(.*)$/);
    if (item) {
      flushParagraph();
      list.push(item[1]);
      return;
    }
    flushList();
    paragraph.push(line);
  });
  flushParagraph();
  flushList();
  return blocks;
}
